export default function AnalyticsReasons() {
  const reasons = [
    {
      number: '01',
      icon: 'ri-database-2-line',
      title: 'Накопление данных (Big Data)',
      desc: 'Чтобы система начала давать точные советы, ей нужна статистика. Если вы настроите аналитику через полгода, вы потеряете данные о поведении первых (самых важных) клиентов.',
      accent: 'Потерянные данные — потерянные деньги.',
      color: 'from-orange-50 to-orange-100/50',
      border: 'border-orange-200',
      icon_bg: 'bg-orange-500',
    },
    {
      number: '02',
      icon: 'ri-funds-line',
      title: 'Оптимизация бюджета с первого дня',
      desc: 'Вы сразу видите, какие рекламные кампании приносят продажи, а какие — «пустой» трафик. Это позволяет вовремя остановить убыточные кампании и перенаправить деньги в прибыльные каналы.',
      accent: 'Каждый вложенный рубль работает на результат.',
      color: 'from-teal-50 to-teal-100/50',
      border: 'border-teal-200',
      icon_bg: 'bg-teal-600',
    },
    {
      number: '03',
      icon: 'ri-eye-line',
      title: 'Честный контроль продаж',
      desc: 'Сквозная аналитика — это честное зеркало вашего бизнеса. Она показывает реальную эффективность продаж. Вы увидите не только путь клиента до заявки, но и то, как быстро и качественно отдел продаж обрабатывает эти лиды.',
      accent: 'Прозрачность на каждом этапе воронки.',
      color: 'from-[#C5A880]/10 to-[#C5A880]/5',
      border: 'border-[#C5A880]/30',
      icon_bg: 'bg-[#C5A880]',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#1A2B4C] rounded-full px-5 py-2 mb-6">
            <i className="ri-alarm-warning-line text-[#C5A880] text-lg"></i>
            <span className="text-white text-sm font-semibold font-['Montserrat'] uppercase tracking-wider">Почему сейчас, а не потом?</span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] font-['Playfair_Display'] leading-tight">
            3 причины внедрить Сквозную Аналитику<br className="hidden sm:block" /> прямо сейчас
          </h2>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {reasons.map((r, i) => (
            <div key={i} className={`relative rounded-3xl border ${r.border} bg-gradient-to-b ${r.color} p-7 sm:p-8 overflow-hidden hover:scale-[1.02] transition-transform duration-300`}>
              {/* Big number bg */}
              <div className="absolute top-4 right-5 text-8xl font-bold text-[#1A2B4C]/5 font-['Playfair_Display'] select-none leading-none">
                {r.number}
              </div>
              {/* Icon */}
              <div className={`w-14 h-14 ${r.icon_bg} rounded-2xl flex items-center justify-center mb-6`}>
                <i className={`${r.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] mb-4 font-['Playfair_Display'] leading-snug">{r.title}</h3>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-5 font-['Montserrat'] text-justify">{r.desc}</p>
              <div className="border-t border-[#1A2B4C]/10 pt-4">
                <p className="text-sm font-semibold text-[#1A2B4C] font-['Montserrat'] italic">{r.accent}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA small */}
        <div className="text-center mt-10 sm:mt-14">
          <a
            href="#analytics-lead-form"
            className="inline-flex flex-col sm:flex-row items-center justify-center gap-2 bg-[#1A2B4C] hover:bg-[#243d6e] text-white px-7 py-4 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 hover:scale-105 cursor-pointer font-['Montserrat'] text-center"
          >
            <span>Начать сейчас — каждый день промедления стоит денег</span>
            <i className="ri-arrow-right-line text-lg flex-shrink-0"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
